// node_modules/material-react-table/locales/es
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { MRT_Localization_EN } from 'material-react-table/locales/en';

import { getCleanPath } from "./URL";

// get all the nodes from table
export const getNodes = (api, filter = false) => {

    var nodes = [];

    // check if MRT instance (although now we assume it is always MRT)
    if(api?.getRowModel){
        
        if(filter){
            nodes = api.getFilteredRowModel().rows;
        }
        else{
            nodes = api.getRowModel().rows;
        }
    }
    
    return nodes;
}

// get all the nodes data
export const getNodesData = (api, filter = false) => {

    var data = [];
    const nodes = getNodes(api,filter);

    nodes.forEach(node => {
        // node.original for mrt
        if(node?.original){
            data.push(node.original);
        }
    });

    return data;
}

// get menus where needs a selection if on any subitem
export const getNeedsSelection = (path) => {

    var parent = null;

    let cleanPath = getCleanPath(path);
    if(cleanPath){
        cleanPath = cleanPath.replace(/\/(charts|documents)$/, '');
    }

    switch(cleanPath){

        case 'planification/planifications': // parent
        case 'planification/planification_reports':
        case 'planification/configuration/planification_activities':
        case 'planification/configuration/planification_restrictions':
        case 'planification/configuration/planification_lps':
        case 'planification/configuration/planification_holidays':
        case 'planification/configuration/planification_unproductives':
        case 'planification/configuration/planification_zones':        
        case 'planification/configuration/planification_persons':
        case 'planification/configuration/planification_providers':
        case 'planification/configuration/plan_team':
            parent = 'planification/planifications';
            break;
    }

    return {parent};
}

// check the field to be filtered on backend with the selected option
export const getFieldSelection = (path) => {

    let cleanPath = getCleanPath(path);
    if(cleanPath){
        cleanPath = cleanPath.replace(/\/(charts|documents)$/, '');
    }

    // check parent menu if submenu depending on parent
    const fieldSelectionArray = {
        'planification/planifications': 'planification_id'
    };
    var {parent} = getNeedsSelection(path);

    var field = null;

    switch(cleanPath){

        // if workers on planification the field is 'planifications.id' because it is not a table with planification_id
        case 'planification/configuration/plan_team':
            field = 'planifications.id';
            break;

        default:
            if(parent && fieldSelectionArray && Object.hasOwn(fieldSelectionArray,parent)){
                field = fieldSelectionArray[parent];
            }
            break;
    }

    return field;
}

// to manage parameters for the tables, separate by user id
export const getTableParam = (user,table,parameter) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        const tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(
            tables && 
            Object.hasOwn(tables,userId) &&
            Object.hasOwn(tables[userId],table)
        ){
            // selected and options are separated by company under selection parameter
            if (parameter === 'selected' || parameter === 'options') {
             
                const companyId = user?.company || 0;
             
                if (tables[userId][table]?.selection?.[companyId]) {
                    return tables[userId][table].selection[companyId][parameter];
                }
            }
            else {
                if (Object.hasOwn(tables[userId][table], parameter)) {
                    return tables[userId][table][parameter];          
                }
            }
        }

    }
    
    return null;

};

export const setTableParam = (user,table,parameter,value) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        let tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(!tables[userId]){
            tables[userId] = {};
        }

        if(!tables[userId][table]){
            tables[userId][table] = {};
        }

        // selected and options are separated by company under selection parameter
        if (parameter === 'selected' || parameter === 'options') {
            
            const companyId = user?.company || 0;
            
            if (!tables[userId][table].selection) {
                tables[userId][table].selection = {};
            }
            
            if (!tables[userId][table].selection[companyId]) {
                tables[userId][table].selection[companyId] = {};
            }
            
            tables[userId][table].selection[companyId][parameter] = value;
        }
        else {
            tables[userId][table][parameter] = value;
        }

        const json = JSON.stringify(tables);
        localStorage.setItem('tables',json);

        return value;

    }
    
    return null;

};

export const removeTableParam = (user,table,parameter) => {

    if(user?.id && table){
    
        const tablesJson = localStorage.getItem('tables');
        let tables = JSON.parse(tablesJson) || {};
        const userId = user.id;
        let value = null;
        
        if(
            tables && 
            Object.hasOwn(tables,userId) &&
            Object.hasOwn(tables[userId],table)
        ){
            // selected and options are separated by company under selection parameter
            if (parameter === 'selected' || parameter === 'options') {
                
                const companyId = user?.company || 0;
                
                if (tables[userId][table]?.selection?.[companyId]) {
                    value = tables[userId][table].selection[companyId][parameter];
                    tables[userId][table].selection[companyId][parameter] = null;
                }

            }
            else{
                if (Object.hasOwn(tables[userId][table], parameter)) {
                    value = tables[userId][table][parameter];
                    tables[userId][table][parameter] = null;
                }
            }
        }

        const json = JSON.stringify(tables);
        localStorage.setItem('tables',json);

        return value;

    }
    
    return null;

};

// to build the fields for the selected item
export const buildSelectionInfo = (table,data,columns) => {

    var idField = 'id';
    var nameField = 'name';   
    
    //switch(table){
        
    //    case '':
    //        idField = '';
    //        nameField = '';
    //        break;
    //}

    var id = '';
    var name = '';
    if(data && Object.hasOwn(data,idField)){  
        id = data[idField];
    }

    if(data && Object.hasOwn(data,nameField)){  
        name = data[nameField];    
    }
      
    const itemInfo = {
        id: id,
        name: name
    };   

    switch(table){
                
        case 'planification/planifications':
            // get plan info
            var plans = columns?.plan_id?.values;
            var plan = plans?.filter(plan => plan?.id === data['plan_id'])?.pop()?.name;                          
            
            if(plan && plan?.length > 0){
                if(itemInfo.name?.length > 0){
                    itemInfo.nameappend = ' ('+plan+')';
                }
                else{
                    itemInfo.nameappend = plan;
                }
            }
            break;
    }

    return itemInfo;
}

export const getTableConfig = (user, table, parameter = null) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        const tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(
            tables && 
            Object.hasOwn(tables, userId) &&
            Object.hasOwn(tables[userId], table) &&
            Object.hasOwn(tables[userId][table], 'config')
        ){

            let config = tables[userId][table]['config'];

            if(config && config.view){

                const views = tables[userId][table]['views'] || [];
                const activeView = views.find(v => v.id === config.view);

                if(activeView && activeView.config){
                    config = { ...config, ...activeView.config };
                }
                else {
                    config.view = null;
                }

            }

            if(parameter){

                if(config && Object.hasOwn(config, parameter)){
                    return config[parameter];
                }

                return null;

            }
            else {
                return config;
            }

        }

    }
    
    return null;

};

// to check a table config, getting from backend or storage
export const checkTableConfig = (user, table, config, param) => {

    var value = getTableConfig(user,table,param);

    // if not saved, check config
    if(value === null){
        if(config && Object?.hasOwn(config,param)){
            value = config[param];
        }
    }

    return value;
}

export const setTableConfig = (api, user, table, parameter = null, value = null, activeViewId = null) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        let tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(!tables[userId]){
            tables[userId] = {};
        }

        if(!tables[userId][table]){
            tables[userId][table] = {};
        }

        if(activeViewId){

            if(!tables[userId][table]['views']){
                tables[userId][table]['views'] = [];
            }

            const viewsArray = tables[userId][table]['views'];
            const viewIndex = viewsArray.findIndex(v => v.id === activeViewId);

            if(viewIndex !== -1){

                const config = viewsArray[viewIndex].config || {};
                
                if(!parameter){
                    config.columnState = api?.getColumnState();
                    config.groupState = api?.getColumnGroupState();
                    config.filterState = api?.getFilterModel();
                }
                else {

                    switch(parameter){
                        case 'columnState':
                            config[parameter] = api?.getColumnState();
                            break;
                        case 'groupState':
                            config[parameter] = api?.getColumnGroupState();
                            break;
                        case 'filterState':
                            config[parameter] = api?.getFilterModel();
                            break;
                        case 'state':
                            config[parameter] = api?.getState();
                            break;
                        default:
                            config[parameter] = value;
                            break;
                    }

                }
                
                viewsArray[viewIndex].config = config;
                localStorage.setItem('tables', JSON.stringify(tables));
                return config;

            }

        }

        if(!tables[userId][table]['config']){
            tables[userId][table]['config'] = {};
        }

        let config = tables[userId][table]['config'];

        if(!parameter){
            config.columnState = api?.getColumnState();
            config.groupState = api?.getColumnGroupState();
            config.filterState = api?.getFilterModel();
        }
        else {

            switch(parameter){
                case 'columnState':
                    config[parameter] = api?.getColumnState();
                    break;
                case 'groupState':
                    config[parameter] = api?.getColumnGroupState();
                    break;
                case 'filterState':
                    config[parameter] = api?.getFilterModel();
                    break;
                case 'state':
                    config[parameter] = api?.getState();
                    break;
                default:
                    config[parameter] = value;
                    break;
            }

        }

        tables[userId][table]['config'] = config;
        localStorage.setItem('tables', JSON.stringify(tables));
        return config;

    }
    
    return null;

};

export const setTableConfigObject = (user, table, configObject, activeViewId = null) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        let tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(!tables[userId]){
            tables[userId] = {};
        }

        if(!tables[userId][table]){
            tables[userId][table] = {};
        }

        if(activeViewId){

            if(!tables[userId][table]['views']){
                tables[userId][table]['views'] = [];
            }

            const viewIndex = tables[userId][table]['views'].findIndex(v => v.id === activeViewId);

            if(viewIndex !== -1){
                tables[userId][table]['views'][viewIndex].config = { ...configObject };
                localStorage.setItem('tables', JSON.stringify(tables));
                return tables[userId][table]['views'][viewIndex].config;
            }

        }

        tables[userId][table]['config'] = { ...configObject };
        localStorage.setItem('tables', JSON.stringify(tables));
        return tables[userId][table]['config'];

    }
    
    return null;

};

export const removeTableConfig = (user, table, parameter = null) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        let tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(
            tables && 
            Object.hasOwn(tables, userId) &&
            Object.hasOwn(tables[userId], table) &&
            Object.hasOwn(tables[userId][table], 'config')
        ){

            if(parameter){
                if(tables[userId][table]['config'] && Object.hasOwn(tables[userId][table]['config'], parameter)){
                    tables[userId][table]['config'][parameter] = null;
                }
            }
            else {
                tables[userId][table]['config'] = {};
            }

            localStorage.setItem('tables', JSON.stringify(tables));
            return tables[userId][table]['config'];

        }

    }
    
    return null;

};

// return regExp to check if /table/view/N
const viewRegExp = () => {

    //const regExp = new RegExp(`\/${table}\/view\/([0-9]+)`);
    const regExp = /\/([a-zA-Z-_]+)\/(view|fullview)\/([0-9]+)/

    return regExp;
}

// check if we are on table/view/N or table/fullview/N
export const checkViewPath = (path = null) => {

    if(!path){
        path = window.location.pathname;
    }

    var check = false;

    const regExp = viewRegExp();
    if(regExp.test(path)){
        const matches = path.match(regExp);
        // matches[0] => /tickets/view/29
        // matches[1] => tickets (1st group)
        // matches[2] => view or fullview
        // matches[3] => 29 (2nd group)        
        if(matches){
            check = matches;
        }
    }

    return check;
}


// check if it is view or fullview
export const checkViewType = (path = null) => {
    
    var result = null;
    const matches = checkViewPath(path);
    
    if(matches && matches?.length > 2){
        result = matches[2];
    }

    return result;
}

// check if we are on table/view/N
// or table/fullview/N => to show in full page without menu and top bar
export const checkIfItemView = (path = null) => {

    var result = false;

    const matches = checkViewPath(path);

    if(matches){
       result = parseInt(matches[3]);        
    }

    return result;
}

// replace /table/view/NN => /table to check different things
export const replaceIfItemView = (path = null) => {

    if(checkIfItemView()){

        const regExp = viewRegExp();

        if(!path){
            path = window.location.pathname;
        }
        
        path = path.replace(regExp,"/$1");
    }

    return path;
}

// check if forgot password url
// /forgot
export const checkIfForgot = () => {

    var result = false;

    const regExp = /\/forgot\/?$/;

    if(regExp.test(window.location.pathname)){
        result = true;
    }

    return result;
}

// to check if view item details
export const checkViewItem = (router, values = 'all') => {

    var viewItemId = null;
    var viewType = null;

    const getViewPathValues = checkViewPath(router.pathname);        

    if(getViewPathValues && getViewPathValues[2]){
        viewType = getViewPathValues[2];
        viewItemId = getViewPathValues[3];
    }

    if(values){
        switch(values){

            case 'id':
                return viewItemId;
                //break;

            case 'type':
                return viewType;
                //break;

            case 'all':
            default:
                return { viewType, viewItemId };
                //break;
        }
    }

    return { viewType, viewItemId };
}

// translations for mrt table
export const getLocalization = (language, t) => {
    
    let localization = language === 'es' ? MRT_Localization_ES : MRT_Localization_EN;
    
    if (t) {
        localization = {
            ...localization, 
            filterMode: t('table.filterMode'), 
            filterOperator: t('table.filterOperator'),
            rowsPerPage: t('table.rowsPerPage'),
            showHideColumns: t('table.showHideColumns'),
            //showHideFilters: t('table.showHideFilters')
        };
    }
    
    return localization;
};

export const getTableViews = (user, table) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        const tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(tables && tables[userId] && tables[userId][table] && tables[userId][table]['views']){
            return tables[userId][table]['views'] || [];
        }

    }
    
    return [];

};

export const setTableView = (user, table, viewName, configData, viewId = null) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        let tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(!tables[userId]){
            tables[userId] = {};
        }

        if(!tables[userId][table]){
            tables[userId][table] = {};
        }

        if(!tables[userId][table]['views']){
            tables[userId][table]['views'] = [];
        }

        const id = viewId || String(Date.now());
        const viewsArray = tables[userId][table]['views'];
        const existingIndex = viewsArray.findIndex(v => v.id === id);

        if(!viewId || viewId !== '0'){

            const hasDefaultView = viewsArray.some(v => v.id === '0');
            const hasUserViews = viewsArray.some(v => v.id !== '0');

            if(!hasDefaultView && !hasUserViews){
                const baseConfig = tables[userId]?.[table]?.['config'] || {};
                viewsArray.push({ id: '0', name: 'default', config: { ...baseConfig } });
            }

        }

        const newView = {
            id: id,
            name: viewName,
            config: configData
        };

        if(existingIndex !== -1){
            viewsArray[existingIndex] = newView;
        }
        else {
            viewsArray.push(newView);
        }

        localStorage.setItem('tables', JSON.stringify(tables));
        return id;

    }
    
    return null;

};

export const deleteTableView = (user, table, viewId) => {

    if(user?.id && table && viewId){

        const tablesJson = localStorage.getItem('tables');
        let tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(tables && tables[userId] && tables[userId][table] && tables[userId][table]['views']){

            let viewsArray = tables[userId][table]['views'];
            let views = viewsArray.filter(v => v.id !== viewId);
            const hasUserViews = views.some(v => v.id !== '0');

            if(!hasUserViews){
                views = [];
            }

            tables[userId][table]['views'] = views;

            if(views.length === 0){
                if(tables[userId][table]['config']){
                    tables[userId][table]['config'].view = null;
                }
            }

            localStorage.setItem('tables', JSON.stringify(tables));
            return true;

        }

    }
    
    return false;

};

export const setActiveTableView = (user, table, viewId) => {

    if(user?.id && table){

        const tablesJson = localStorage.getItem('tables');
        let tables = JSON.parse(tablesJson) || {};
        const userId = user.id;

        if(!tables[userId]){
            tables[userId] = {};
        }

        if(!tables[userId][table]){
            tables[userId][table] = {};
        }

        if(!tables[userId][table]['config']){
            tables[userId][table]['config'] = {};
        }

        tables[userId][table]['config'].view = viewId;
        localStorage.setItem('tables', JSON.stringify(tables));
        return true;

    }
    
    return false;

};

export const getTablesConfig = () => {

    const tablesJson = localStorage.getItem('tables');

    if(tablesJson){
        try{
            return JSON.parse(tablesJson);
        }
        catch(e){
            return {};
        }
    }

    return {};
};

export const setTablesConfig = (tables) => {
    localStorage.setItem('tables', typeof tables === 'string' ? tables : JSON.stringify(tables));
};

export const removeTablesConfig = () => {
    localStorage.removeItem('tables');
};
